<form class="form-inline">
  <div class="form-group">
    <div class="input-group" (clickOutside)="d.close()">
      <input class="form-control"
             name="dp"
             #datePicker="ngModel"
             ngbDatepicker #d="ngbDatepicker"
             [dayTemplate]="customDay"
             [displayMonths]="1"
             [navigation]="'select'"
             [outsideDays]="'visible'"
             [placement]="'top-right'"
             [showWeekNumbers]="true"
             [(ngModel)]="model"
             [readonly]="true"
             (change)="onDeliveryChange()"
             (dateSelect)="onDeliveryChange();"
             required
      >
      <div class="input-group-append">
        <button class="btn btn-nopadding btn-outline-secondary calendar feather icon-calendar" (click)="d.toggle();"
                type="button"></button>
      </div>
    </div>
    <div class="messages text-danger"
         *ngIf="datePicker.invalid && showWarning && datePicker.errors?.required">
      {{'errors.required'|translate}}
    </div>
  </div>
</form>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
  <span class="custom-day" [class.focused]="focused"
        [class.bg-primary]="isWeekSelected(date)" [class.hidden]="date.month !== currentMonth" [class.text-muted]="isDisabled(disabled, date, currentMonth)">
    {{ date.day }}
  </span>
</ng-template>
